import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="wrap flex min-h-[68vh] flex-col items-center justify-center pt-16 text-center">
      <div className="pointer-events-none select-none text-[10rem] font-black leading-none text-primary-500/10 md:text-[14rem]">404</div>
      <h1 className="-mt-14 serif text-2xl font-black text-foreground-950 md:-mt-20 md:text-3xl">这一页还没上架</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你要找的内容（{location.pathname}）暂时不存在，可能被重新整理或移动了。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link to="/" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600">
          <i className="ri-home-4-line" /> 返回首页
        </Link>
        <Link to="/#collections" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-300 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700">
          去逛专题合集
        </Link>
      </div>
    </div>
  );
}